// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:1439px){.header[data-v-65cefb4c]{padding:16px 40px}}", ""]);
// Exports
module.exports = exports;
